<template>
  <v-dialog
    :value="show"
    persistent
    max-width="750px"
    transition="dialog-transition"
    @input="close"
  >
  <v-card class="px-4 pt-4 pb-4">
    <v-card-title>
      <h2>
        Instrucciones de pago
      </h2>
    </v-card-title>
    <v-card-text class="pb-4">
      <vue-editor v-model="text" :editorToolbar="editorToolbar"></vue-editor>
    </v-card-text>
    <v-card-actions class="pr-2">
        <v-spacer />
        <v-btn flat color="black" @click="$emit('close')">
          Cerrar
        </v-btn>
        <v-btn flat class="k-orange-linear-text" @click="save">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { VueEditor } from 'vue2-editor';
import emailEditorToolbarMixin from '@/mixins/emailEditorToolbar';

export default {
  components: {
    VueEditor,
  },
  mixins: [
    emailEditorToolbarMixin,
  ],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      text: '',
    };
  },
  methods: {
    close($event) {
      if (!$event) {
        this.$emit('close');
      }
    },
    save() {
      this.$emit('update:text', this.text);
      this.$emit('close');
    },
  },
  watch: {
    show() {
      if (this.text !== this.value) {
        this.text = this.value;
      }
    },
  },
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/global/DialogEditor.vue